/** Chart/table horizontal pagination page size for Price Pack Architecture. */
export const PPA_CHART_PAGE_LIMIT = 50;

/** Minimum spacing between KPI range min/max and adjacent breakpoints (sliders, inputs). */
export const KPI_RANGE_GAP = 1;

/** Minimum allowed uniform bin count and bin size in KPI axis configuration. */
export const MIN_KPI_BIN_COUNT = 1;

/** Default number of uniform bins when KPI axis configuration has no meta override. */
export const DEFAULT_UNIFORM_BIN_COUNT = 5;

/** Maximum custom breakpoints allowed in KPI axis configuration. */
export const MAX_CUSTOM_BREAKPOINTS = 10;

/** Fallback min/max bounds for KPI axis configuration when chart meta is unavailable. */
export const DEFAULT_KPI_DATA_RANGE = {
    defaultMin: 0,
    defaultMax: 100,
} as const;

/** Navigation/editing keys allowed in KPI integer-only range inputs (PA-07). */
export const KPI_INTEGER_CONTROL_KEYS = new Set([
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
]);
